import { useEffect, useState } from 'react';
import ApiDatabase from 'server';
import { ChevronDown, ChevronRight, Star } from '../../../../../assets/icons';
import usefetchdata from '../../../../../hooks/usefetchdata';
import Divider from '../../../../divider/divider';
import StarRating from '../../../../starRating/starRating';
import Tooltip from '../../../../tooltips/Tooltips';
import ReviewCard from '../../../../card/ReviewCard';

const MissionRowSkeleton = () => (
  <div className="animate-pulse flex flex-col gap-2">
    {[1, 2, 3, 4, 5].map((i) => (
      <div key={i}>
        <div className="flex justify-between gap-2">
          <div className="my-auto"><div className="h-2 w-60 bg-gray-200 rounded" /></div>
          <div className="my-auto flex gap-4">
            <div className="my-auto"><div className="h-2 w-32 bg-gray-200 rounded" /></div>
            <div className="my-auto border rounded w-9 h-9 flex"><div className="h-4 w-4 bg-gray-200 rounded m-auto" /></div>
          </div>
        </div>
        <Divider />
      </div>
    ))}
  </div>
);

const ReviewTempWorker = ({ idUser }) => {
  const token = localStorage.getItem('xsrfToken');
  const { userData } = usefetchdata();
  const [reviewsByMission, setReviewsByMission] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);
  const [openMissionTitle, setOpenMissionTitle] = useState('');

  useEffect(() => {
    if (token && idUser && userData._id) {
      setIsWaiting(true);
      ApiDatabase.getReviewsByTempWorkerGroupByMissions(
        { token, idUser },
        (data) => { setIsWaiting(false); setReviewsByMission(data.missionsReviews); },
        () => { setIsWaiting(false); }
      );
    }
  }, [userData._id, token, idUser]);

  if (isWaiting) return <MissionRowSkeleton />;

  if (!reviewsByMission?.length) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <Star wh={32} color="#9CA3AF" />
        </div>
        <div className="text-gray-900 font-semibold text-lg mb-2">Aucun avis</div>
        <div className="text-gray-500 text-sm text-center max-w-md">
          Aucun avis n'a encore été donné pour cet intérimaire.
        </div>
      </div>
    );
  }

  return (
    <>
      {reviewsByMission.map((mission) => {
        const isOpen = openMissionTitle === mission.title;
        return (
          <div key={mission._id || mission.title}>
            <div className="flex justify-between gap-2">
              <div className="my-auto">{mission.title}</div>
              <div className="my-auto flex gap-4">
                <Tooltip text={`${Math.round(mission.rating * 100) / 100}/5 avis positif`} placement="top">
                  <div><StarRating rating={mission.rating} /></div>
                </Tooltip>
                <button
                  type="button"
                  className="my-auto border rounded hover:bg-gray-100 w-9 h-9 flex"
                  onClick={() => setOpenMissionTitle(isOpen ? '' : mission.title)}
                >
                  <div className="m-auto">
                    {isOpen ? <ChevronDown wh={20} color="#374151" /> : <ChevronRight wh={20} color="#374151" />}
                  </div>
                </button>
              </div>
            </div>
            {isOpen && (
              <div className="flex flex-col gap-2 mt-2">
                {mission.reviews.map((review) => (
                  <ReviewCard key={review._id} review={review} />
                ))}
              </div>
            )}
            <Divider />
          </div>
        );
      })}
    </>
  );
};

export default ReviewTempWorker;
